import logo from "../assets/images/Artieve-Logo.png"
import NavBar from './NavBar'
import '../styles/header.css'
import { UserContext } from "../context/UserContext"
import { useContext } from "react"
import { Link } from "react-router-dom"

const Header = ({ shouldShowNav }) => {
  const { loggedInUser } = useContext(UserContext) || {}

  return (
    <div id="header">
      <Link to="/" className="header-logo">
        <img src={logo} alt="Artieve Logo" />
        <h1>Artieve</h1>
      </Link>
      {loggedInUser ? (
        shouldShowNav && <NavBar />
      ) : (
        <span className="link-item">
          <Link to="/register">Sign up</Link>
          <Link to="/login">Log in</Link>
        </span>
      )}
    </div>
  )
}

export default Header